import { Avatar, Card, Link, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple } from 'Images';
import { useEffect } from 'react';

interface IContactCard {
  title: string;
  subtitle: string;
  img: string;
  href: string;
  cardLinkFocusRef: any;
}
export const ContactCard = ({
  img,
  subtitle,
  title,
  href,
  cardLinkFocusRef,
}: IContactCard) => {
  const isDesktop = useIsDesktop();

  useEffect(() => {
    if (cardLinkFocusRef?.current) {
      setTimeout(() => {
        cardLinkFocusRef.current.focus();
      }, 700);
    }
  }, [cardLinkFocusRef]);

  return (
    <Card
      elevation={0}
      sx={{
        width: isDesktop ? '444px' : '292px',
        backgroundColor: '#fff',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        borderRadius: '16px',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      <Link
        underline={'none'}
        color={'inherit'}
        href={href}
        target={'_blank'}
        rel={'noopener'}
        role='link'
        ref={cardLinkFocusRef}
      >
        <Stack
          direction={'row'}
          padding={isDesktop ? '61px 16px 24px 24px' : '20px 7px 20px 48px'}
          justifyContent={'space-between'}
          gap={'10px'}
        >
          <Stack gap={'8px'}>
            <Typography
              variant={'body1'}
              color={'text.secondary'}
              component='h2'
            >
              {title}
            </Typography>
            <Typography variant={'body6'}>{subtitle}</Typography>
          </Stack>
          <Avatar
            alt={''}
            src={AccordionArrowPurple}
            sx={{
              width: isDesktop ? '45px' : '32px',
              height: isDesktop ? '45px' : '32px',
              rotate: '90deg',
              alignSelf: 'center',
            }}
          />
          <Avatar
            alt={''}
            src={img}
            sx={{
              position: 'absolute',
              top: isDesktop ? '-25%' : '22%',
              left: isDesktop ? '40%' : '-12%',
              zIndex: 1,
              width: isDesktop ? '90px' : '70px',
              height: isDesktop ? '90px' : '70px',
            }}
          />
        </Stack>
      </Link>
    </Card>
  );
};
